import {useHistory} from "react-router-dom";

export default function useGETUrlToObject(exceptions = []) {
    const {location} = useHistory();

    const searchParams = new URLSearchParams(location.search);
    const search = Object.fromEntries(Array.from(searchParams.entries()).filter(removeSpecificEntries));

    Object.entries(search).forEach(([key, value]) => {
        try {
            search[key] = JSON.parse(value);
        } catch (e) {
            // do nothing
        }
    });

    exceptions.forEach((exception) => {
        delete search[exception];
    });

    return search;
}

// Everything in the URL is added is the search object, except for the keys in this list
function removeSpecificEntries([key]) {
    return !['quoteId'].includes(key)
}
